'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';

import medprevPin from '@/app/(main)/(pages)/_components/branches-near-you-section/assets/medprev-pin.png';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Card } from '@/components/ui/card.component';
import { Location } from '@/app/(main)/(pages)/_components/branches-near-you-section/location.component';
import { getUserLocationStorage } from '@/storage/location.storage';

interface FindBranchesNearYouProps {
  onClickLocationCallback?: () => void;
}

export const FindBranchesNearYou = ({ onClickLocationCallback }: FindBranchesNearYouProps) => {
  const userLocation = getUserLocationStorage();
  const noLocation = !userLocation?.city && !userLocation?.state;
  const description = noLocation ? 'Busque pela cidade, bairro ou rua' : 'Nenhuma unidade física disponível nesta cidade.';

  return (
    <ContentContainer className="mb-10 xl:mb-0">
      <section
        data-testid={DataTestIdEnum.CITY_BRANCHES_NEAR_YOU_SECTION}
        className="flex flex-col gap-4"
      >
        <Card className="flex flex-col xl:flex-row justify-center items-start xl:items-center gap-6 p-6">
          <Image
            src={medprevPin}
            height={206}
            alt="medprev pin"
            draggable={false}
            className="hidden xl:block"
          />

          <div className="flex flex-col items-start w-full">
            <Typography className="mb-2">{description}</Typography>
            <Location className="w-full" onSelectLocationCallback={onClickLocationCallback} />
          </div>

          <Image
            src={medprevPin}
            height={206}
            alt="medprev pin"
            draggable={false}
            className="block xl:hidden self-center"
          />

          <div className="flex flex-col items-center justify-center w-full xl:basis-1/3 xl:mt-7">
            <Typography variant={TypographyVariant.MEDIUM_SUBTITLE} className="font-bold xl:text-center">
              +100 unidades
            </Typography>
            <Typography>em todo Brasil</Typography>
          </div>
        </Card>
      </section>
    </ContentContainer>
  );
};
